
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"synchronizedTooltip":"Diese Einstellung gilt für das Kombinationsdiagramm. Sie wird automatisch für alle Diagramm-Layer übernommen."},"en":{"synchronizedTooltip":"This setting applies to the combination chart. It is automatically applied to all chart layers."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();